import { PropsWithChildren, useEffect } from 'react';
import { useAuthContext } from '@/src/features/app/store/auth/context';
import { SessionContext } from '@/src/features/app/store/session/context';
import { useSessionStore } from '@/src/features/app/store/session/store';

export const SessionContextProvider = ({ children }: PropsWithChildren) => {
  const { state: { user } } = useAuthContext();
  const store = useSessionStore();

  useEffect(() => {
    const exp = user
      ? new Date(user.exp * 1000)
      : new Date();
    const now = new Date();
    let diff = exp.getTime() - now.getTime();

    const interval = diff > 0
      ? setInterval(() => {
        diff = diff - 1000;
        store.update(diff);

        if (diff <= 0) {
          store.terminate();
        }
      }, 1000)
      : null;

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [user, store]);

  return (
    <SessionContext.Provider value={store}>
      {children}
    </SessionContext.Provider>
  );
};
